import React from "react";
import { reviews } from "../mock";
import Stars from "./Stars";

// Feature the reviews that include customer-posted photos.
const featured = reviews.filter((r) => r.photos && r.photos.length).slice(0, 3);

function StripCard({ r }) {
  return (
    <div className="flex flex-col rounded-2xl border border-navy/10 bg-white p-5 shadow-sm">
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-navy font-heading font-bold text-white">
          {r.name.charAt(0)}
        </div>
        <div className="min-w-0">
          <p className="truncate text-sm font-bold text-navy">{r.name}</p>
          <div className="flex items-center gap-2">
            <Stars value={r.rating} size={12} />
            <span className="text-[11px] text-navy/50">{r.when}</span>
          </div>
        </div>
        <img
          src="/images/google-g.svg"
          alt="Google"
          className="ml-auto h-5 w-5"
          onError={(e) => (e.currentTarget.style.display = "none")}
        />
      </div>
      <p className="mt-3 line-clamp-4 text-sm leading-relaxed text-navy/75">{r.text}</p>
      {r.photos && (
        <div className="mt-3 flex gap-2">
          {r.photos.slice(0, 3).map((p, i) => (
            <img
              key={i}
              src={p}
              alt={`${r.name} posted photo`}
              className="h-16 w-16 rounded-lg border border-navy/10 object-cover"
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default function ReviewsStrip() {
  return (
    <section className="border-b border-navy/10 bg-gray-50">
      <div className="mx-auto max-w-7xl px-4 py-10 lg:px-8">
        <div className="mb-6 flex flex-col items-center text-center">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand">Loved by Aussies</p>
          <h2 className="mt-1 font-heading text-2xl font-extrabold text-navy md:text-3xl">
            What our customers say
          </h2>
        </div>
        <div className="grid gap-5 md:grid-cols-3">
          {featured.map((r, i) => (
            <StripCard key={i} r={r} />
          ))}
        </div>
        <div className="mt-6 text-center">
          <a href="#reviews" className="text-sm font-bold uppercase tracking-wide text-navy transition-colors hover:text-brand">
            Read all customer reviews &rarr;
          </a>
        </div>
      </div>
    </section>
  );
}
